// Environment configuration for browser compatibility
// Note: Webpack DefinePlugin replaces process.env.REACT_APP_* at build time
// Direct access to environment variables (webpack will replace these at build time)

// Direct access - webpack DefinePlugin will replace process.env.REACT_APP_GOOGLE_MAP_KEY with the actual value
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || '';

// Direct access to other environment variables
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://admin.alot263.com';
export const CLIENT_HOST_URL = process.env.REACT_APP_CLIENT_HOST_URL || 'https://alot263.com';

// Debug: Log the API key to console (remove in production)
if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
  if (GOOGLE_MAPS_API_KEY) {
    console.log('✅ Google Maps API Key: Present (length:', GOOGLE_MAPS_API_KEY.length, ')');
    console.log('💡 If you see API errors, ensure these APIs are enabled in Google Cloud Console:');
    console.log('   - Maps JavaScript API');
    console.log('   - Places API');
    console.log('   - Geocoding API');
    console.log('   - Directions API');
  } else {
    console.warn('⚠️ Google Maps API Key: Missing - Maps functionality may not work properly');
    console.warn('   Please set REACT_APP_GOOGLE_MAP_KEY in your .env file');
  }
}

export default {
  GOOGLE_MAPS_API_KEY,
  BASE_URL,
  CLIENT_HOST_URL,
};